import SearchBarHandler from 'components/Content/SectionHandler/SearchBarHandler/SearchBarHandler';
import { withSearchBarHandlerProps } from 'components/Content/SectionHandler/SearchBarHandler/withSearchBarHandlerProps';

export default withSearchBarHandlerProps(SearchBarHandler);
